/* React */
import React from "react";

/* Font-Awesome */
import { faChartSimple } from "@fortawesome/free-solid-svg-icons";

/* Stylesheet */
import styles from "./EmptyChartContainer.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/* Interfaces */
interface EmptyChartContainerProps {
  scssProps?: ScssProps;
}

interface ScssProps {
  height: string;
}

const EmptyChartContainer: React.FC<
  EmptyChartContainerProps
> = ({ scssProps }) => {
  return (
    <div
      style={{ height: scssProps?.height }}
      className={styles.empty_chart_container}
    >
      <div className={styles.wrapper_container}>
        <FontAwesomeIcon
          className={styles.icon}
          icon={faChartSimple}
        />
        <div className={styles.label}>
          No data available
        </div>
      </div>
    </div>
  );
};

export default EmptyChartContainer;
